function pickBoolean(value) {
  return value !== null && value !== undefined;
}

function buildCallTranscriptRoute(context, options = {}) {
  const {
    reportCategory,
    reportObjId,
    reporterId,
    targetId,
  } = context;

  if (reportCategory !== "CALL") {
    return null;
  }

  const isV2 = options.transcriptVersion === "v2";
  const name = isV2 ? "CallContentV2" : "CallContent";
  const params = {
    roomId: reportObjId,
  };

  const query = {};
  if (isV2 && pickBoolean(options.reportId)) {
    query.reportId = options.reportId;
  } else {
    query.userId = reporterId;
    query.targetUserId = targetId;
  }

  return {
    name,
    params,
    query,
  };
}

module.exports = {
  buildCallTranscriptRoute,
};
